import { render, staticRenderFns } from "./user-picker.vue?vue&type=template&id=51e0fd1e&"
import script from "./user-picker.vue?vue&type=script&lang=ts&"
export * from "./user-picker.vue?vue&type=script&lang=ts&"
import style0 from "./user-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports